// extracted by mini-css-extract-plugin
module.exports = {"list":"Stats_list__1cf9z","item":"Stats_item__2ZG1-","optionsPanel":"Stats_optionsPanel__bOQWa","sortSection":"Stats_sortSection__1kBUR"};